<template>
    <div>
        <div class="text-sm" :class="[isError ? 'text-red-500' : 'text-gray-800']">
            {{inputLbl.name}}
        </div>
        <div class="relative pb-5">
            <input type="tel"
                class="w-full bg-white px-3 py-1 placeholder-gray-500"
                :class="[isError ? 'border border-red-500' : 'border']"
                v-model="content"
                :placeholder="inputLbl.placeholder"
                :maxlength="inputMaxLength"
                @input="onChange()">
            <div class="text-red-500 text-sm absolute bottom-0 left-0" v-if="isError">
                {{getErrorMsg}}
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isFirstSave (optional) Show/Hide Error after save.
 * @property {Boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputNationalId",
    props: {
        //v-model
        inputValue:     { type: String },
        //props
        errorInfo:      { type: Object, required: true },
        isFirstSave:    { type: Boolean, default: true },
        isShowErrorLbl: { type: Boolean, default: false },
        //text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            content: this.inputValue,
            inputMaxLength: 13,
            inputMinLength: 13,
        };
    },
    computed: {
        isError: function() {
            if (this.isShowErrorLbl && !this.isFirstSave && !this.errorInfo.isValid) {
                return true;
            }
            return false;
        },
        getErrorMsg: function() {
            if (this.isShowErrorLbl && !this.isFirstSave && !this.errorInfo.isValid) {
                return this.errorInfo.msg;
            }
            return '';
        },
    },
    created: function() {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            //Set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            //Required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            //Too short
            if (this.inputLbl.too_short && (this.content.length < this.inputMinLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.inputMinLength));
                return;
            }
            //InValid format
            if (this.inputLbl.invalid) {
                if (!Util.isNationalIdCard(this.content)) {
                    this.errorInfo.setValid(false);
                    this.errorInfo.setMsg(this.inputLbl.invalid);
                    return;
                }
            }
        },
        onChange: function() {
            var result = this.content;
            result = RegxHelper.removeNotNumber(result);

            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
